<script lang="ts">
  import type { PlayerInterface } from '@foundation-player/loader';
  import { getContext } from 'svelte';
  import Speed from '../../shared/assets/icons/Speed.svelte';
  import type { FocusItem, FocusLayer } from '../../shared/focus-manager/focus-types';
  import type { PlayerStateContext } from '../../shared/types/player-state';
  import type { UIConfig } from '../types/ui-config';
  import MenuButton from '../../shared/components/menu/MenuButton.svelte';

  export let player: PlayerInterface;
  export let focusLayer: FocusLayer;
  export let focusName: FocusItem;

  const { playbackSpeed, linearAdPlaying } = getContext<PlayerStateContext>('playerState');
  const { playbackSpeedOptions } = getContext<UIConfig>('uiConfig');

  const defaultSpeedOptions = [0.5, 0.8, 1.0, 1.3, 1.5, 1.8, 2.0];

  // When the playbackSpeedOptions is set in the UI config, we calculate the
  // intersection of the default speed options and the given options (always
  // keeping the value of 1.0),
  const speedOptions = playbackSpeedOptions
    ? defaultSpeedOptions.filter((value) => value === 1.0 || playbackSpeedOptions.includes(value))
    : defaultSpeedOptions;

  const formatPlaybackSpeed = (playbackSpeed: unknown): string => `${(playbackSpeed as number).toFixed(1)}x`;

  const setPlaybackSpeed = (event: CustomEvent<number>) => {
    if (!$linearAdPlaying) {
      player.setPlaybackSpeed(event.detail);
    }
  };

  $: formattedPlaybackSpeed = formatPlaybackSpeed($playbackSpeed);
  $: playbackSpeedCanBeChanged = speedOptions.length > 1 || !speedOptions.includes($playbackSpeed);
</script>

{#if !$linearAdPlaying && playbackSpeedCanBeChanged}
  <MenuButton
    label="Wiedergabegeschwindigkeit anpassen (aktuell {formattedPlaybackSpeed})"
    menuLabel="Wiedergabegeschwindigkeit anpassen"
    menuItems={speedOptions}
    formatMenuItem={formatPlaybackSpeed}
    selectedMenuItem={$playbackSpeed}
    on:selectItem={setPlaybackSpeed}
    {focusLayer}
    {focusName}
  >
    <Speed speed={formattedPlaybackSpeed} aria-hidden={true} />
  </MenuButton>
{/if}
